import React from 'react'
import { Row } from '@ublique/components/Grid'
import Button from '@ublique/components/Button'

export default ({ t, onCancelClick, onSubmit, disabled }) => (
  <Row className='buttons-footer'>
    <a onClick={onCancelClick}>{t('WizardPlatform:SecondaryButtonLabel')}</a>
    <Button disabled={disabled} onClick={onSubmit}>
      {t('WizardPlatform:SaveButtonLabel')}
    </Button>
  </Row>
)
